var _linearGradient, _path, _linearGradient2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocxFileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay15mXZwsMgjHf8cOP0e8a",
    x1: 32,
    x2: 32,
    y1: 3.75,
    y2: 59.299,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ay15mXZwsMgjHf8cOP0e8a)",
    d: "M50,11H35V8.975c0-0.938-0.432-1.801-1.185-2.367c-0.763-0.575-1.73-0.755-2.651-0.488 l-18.561,5.342C10.482,12.072,9,14.025,9,16.211v31.578c0,2.187,1.482,4.14,3.603,4.75l18.561,5.342 c0.28,0.081,0.564,0.12,0.845,0.12c0.645,0,1.274-0.208,1.806-0.608C34.568,56.827,35,55.963,35,55.026V53h15c2.757,0,5-2.243,5-5 V16C55,13.244,52.757,11,50,11z M33,55.026c0,0.304-0.142,0.584-0.388,0.77c-0.257,0.193-0.583,0.253-0.896,0.164l-18.56-5.342 C11.887,50.252,11,49.089,11,47.789V16.211c0-1.3,0.887-2.463,2.156-2.828l18.56-5.342c0.312-0.09,0.638-0.03,0.896,0.164 C32.858,8.391,33,8.671,33,8.975V11v42V55.026z M53,48c0,1.654-1.346,3-3,3H35v-6h14v-2H35v-4h14v-2H35v-4h14v-2H35v-4h14v-2H35v-4 h14v-2H35v-6h15c1.654,0,3,1.346,3,3V48z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay15mXZwsMgjHf8cOP0e8b",
    x1: 22,
    x2: 22,
    y1: 23.833,
    y2: 41.5,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6abff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ay15mXZwsMgjHf8cOP0e8b)",
    d: "M16.869,40l-3.3-14h2.62l1.28,6.265c0.34,1.767,0.66,2.735,0.88,4.735h0.04 c0.22-2,0.6-2.925,0.98-4.756L20.83,26h2.581l1.34,5.883c0.34,1.724,0.62,3.117,0.82,4.117h0.04c0.24-1,0.56-2.458,0.92-4.224 l1.4-5.776h2.5l-3.621,14H24.17l-1.4-6.61C22.43,31.731,22.19,30,22.03,29h-0.04c-0.24,1-0.5,2.731-0.9,4.39L19.529,40H16.869z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocxFileIcon);
export default __webpack_public_path__ + "static/media/docx-file-icon.094fafc77ba4dec7e21c83e033b1be35.svg";
export { ForwardRef as ReactComponent };